module.exports = __webpack_public_path__ + "static/scale-model-of-rosicrucian-egyptian-museum-in-san-jose-california-fc39ac4f813342003f971e7892ee4d26.png";